import { getClient, getCurrentScope } from './currentScopes.js';
import { dropUndefinedKeys } from './utils-hoist/object.js';

/**
 * Send user feedback to Sentry.
 */
function captureFeedback(params) {
  var hint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var scope = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : getCurrentScope();
  var message = params.message,
    name = params.name,
    email = params.email,
    url = params.url,
    source = params.source,
    associatedEventId = params.associatedEventId,
    tags = params.tags;
  var feedbackEvent = {
    contexts: {
      feedback: dropUndefinedKeys({
        contact_email: email,
        name: name,
        message: message,
        url: url,
        source: source,
        associated_event_id: associatedEventId
      })
    },
    type: 'feedback',
    level: 'info',
    tags: tags
  };
  var client = scope && scope.getClient() || getClient();
  if (client) {
    client.emit('beforeSendFeedback', feedbackEvent, hint);
  }
  var eventId = scope.captureEvent(feedbackEvent, hint);
  return eventId;
}
export { captureFeedback };